/**
 * トップページRecruitエリア
 */
import ResizeWatch from '../utils/ResizeWatch';
import ScrollWatch from '../utils/ScrollWatch';
import AnyStore from '../common/AnyStore';
import recruitMovie from './recruitMovie';

export default class recruitAd {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'recruitAd';
    this.isStart = false;
    this.isAnimStart = false;
    this.isBgStart = false;
    this.isBgOnly = false;
    this.preventWidth = 0;
    this.config = {
      bgMinH: {
        pc: function() {
          return 640;
        },
        sp: function() {
          return (800 / 750) * AnyStore.getWindowWidth();
        }
      },
      bgH: {
        pc: function() {
          return 600;
        },
        sp: function() {
          return (500 / 750) * AnyStore.getWindowWidth();
        }
      }
    };

    this.fadeObject = [];
    this.titleObject = [];

    this.init();
  }

  /**
   * 表示前
   */
  init() {
    // dom
    this.el = document.getElementById('js-recruit-ad');

    // domがあるときだけ
    if (this.el) {
      this.isBgOnly = (this.el.querySelector('.p-ad-recruit__summary')) ? false : true;

      if (!this.isBgOnly) {
        // テキスト部分のアニメ準備
        this.fadeObject.push(this.el.querySelector('.title-caption'));
        this.fadeObject.push(this.el.querySelector('.title-sub'));
        this.fadeObject.push(this.el.querySelector('.p-link-view'));
        for (let i = 0; i < this.fadeObject.length; i++) {
          TweenMax.set(this.fadeObject[i], {opacity: 0});
        }

        this.titleObject = this.el.querySelectorAll('.title-main > span');
        for (let i = 0; i < this.titleObject.length; i++) {
          TweenMax.set(this.titleObject[i], {width: 0});
        }

        // timelinemax設定
        this.setTimeline();
      }

      // 背景
      this.recruitMovie = new recruitMovie();

      // イベント
      ResizeWatch.registerObserver(this.name, this);
      ScrollWatch.registerObserver(this.name, this);
    }
  }

  /**
   * 表示時
   */
  start() {
    if (this.el) {
      this.isStart = true;
      this.resizeUpdate();
    }
  }

  setTimeline() {
    this.tl = new TimelineMax({paused: true, onComplete: this.playComp.bind(this)});

    this.tl.add(
      TweenMax.to(this.fadeObject[0], 1.0, {
        opacity: 1,
        ease: Cubic.easeOut
      }), 0);

    this.tl.add(
      TweenMax.staggerTo(this.titleObject, 1.2, {
        width: '100%',
        ease: Quint.easeInOut
      }, 0.1), 0.1);

    this.tl.add(
      TweenMax.to(this.fadeObject[1], 1.0, {
        opacity: 1,
        ease: Cubic.easeOut
      }), 0.1);

    this.tl.add(
      TweenMax.fromTo(this.fadeObject[2], 1.0, {
        opacity: 0,
        x: -100
      }, {
        opacity: 1,
        x: 0,
        ease: Cubic.easeOut
      }), 0.3);
  }

  /**
   * 演出アニメ
   */
  play() {
    this.tl.play();
  }

  /**
   * 演出アニメ完了
   */
  playComp() {
    this.tl.clear();
    this.tl = null;
    this.fadeObject = null;
    this.titleObject = null;
  }

  /**
   * スクロール
   */
  scrollUpdate(_scrollY) {
    if (!this.isStart) return;

    const posStartY = _scrollY + (window.innerHeight * 0.75);
    const posY = _scrollY + window.innerHeight;
    const recStart = AnyStore.getOffsetTop(this.el).top;
    const recEnd = recStart + (window.innerHeight * 2);

    if (posY > recStart && posY < recEnd) {
      // 再生
      if (!this.isBgStart) {
        this.isBgStart = true;
        this.recruitMovie.play();
      }
    } else {
      // 停止
      if (this.isBgStart) {
        this.isBgStart = false;
        this.recruitMovie.pause();
      }
    }

    if (!this.isBgOnly) {
      if (!this.isAnimStart && posStartY > AnyStore.getOffsetTop(this.fadeObject[0]).top) {
        // 文字表示
        this.isAnimStart = true;
        this.play();
      }
    }
  }

  /**
   * リサイズ
   */
  resizeUpdate() {
    const isDevice = AnyStore.setDevice();
    const recW = AnyStore.getWindowWidth();

    let recH = 0;
    if (this.isBgOnly) {
      // タイプがない動画だけなので、通常より縦幅が狭くなる
      recH = this.config.bgH[isDevice]();
    } else {
      recH = window.innerHeight;

      if (recH < this.config.bgMinH[isDevice]()) {
        recH = this.config.bgMinH[isDevice]();
      }
    }

    let isChange = Useragnt.pc || (!Useragnt.pc && this.preventWidth != recW);
    if (isChange) {
      this.el.style.height = recH + 'px';
    }

    // 動画（スライドショー）のサイズ調整
    this.recruitMovie.resizeUpdate(recW, recH);

    // 幅を保存しておく
    this.preventWidth = recW;

    this.scrollUpdate(AnyStore.getScrollTop());
  }
}
